import { DOCUMENT } from '@angular/common';
import { InjectionToken } from '@angular/core';

import { AuthProvider } from '®shared/auth/auth-provider';
import { AuthServiceLogin } from '®shared/auth/auth-service-login';
import { PersonaAuthService } from '®shared/auth/persona-auth.service';
import { PersonaPkceAuthService } from '®shared/auth/persona-pkce-auth.service';
import { PersonaPkceLtiAuthService } from '®shared/auth/persona-pkce-lti-auth.service';
import { User } from '®shared/auth/user';
import { AppConfig } from '®shared/config';

const authenticatedAuthServiceFactory = (
  document: Document,
  appConfig: AppConfig,
  personaAuthService: PersonaAuthService,
  pkceAuthService: PersonaPkceAuthService,
  pkceLtiAuthService: PersonaPkceLtiAuthService,
) => {
  if (!appConfig.tenant.featureFlags.isPersonaPkceLoginEnabled) {
    return personaAuthService;
  }

  const url = new URL(document.location.href);

  const isInPkceLti1p3Context = url.searchParams.has('lti_auth_nonce');
  if (isInPkceLti1p3Context || appConfig.isAnLti1p0EmbeddedSession) {
    return pkceLtiAuthService;
  } else {
    return pkceAuthService;
  }
};

export const AUTHENTICATED_AUTH_SERVICE = new InjectionToken<
  AuthProvider<User> & AuthServiceLogin
>('app.context.authenticatedAuthService');

export const authenticatedAuthServiceProvider = {
  provide: AUTHENTICATED_AUTH_SERVICE,
  useFactory: authenticatedAuthServiceFactory,
  deps: [
    DOCUMENT,
    AppConfig,
    PersonaAuthService,
    PersonaPkceAuthService,
    PersonaPkceLtiAuthService,
  ],
};
